var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default').default;

(function () {
  Motion.file('menu.js', function (require) {
    var _keys = require('./keys');

    var _libInspecting = require('./lib/inspecting');

    var _libInspecting2 = _interopRequireDefault(_libInspecting);

    var Tools = _DT;
    var toEditor = Tools.messageEditor;

    Motion.staticStyles('Menu', {
      '$menu': '#_motiondevtools .ViewMenu',
      '$active': '#_motiondevtools active.Menu, #_motiondevtools .Menu.active, #_motiondevtools .ViewMenu.active, #_motiondevtools .Menu > .active',
      '$item': '#_motiondevtools item.Menu, #_motiondevtools .Menu.item, #_motiondevtools .ViewMenu.item, #_motiondevtools .Menu > .item',
      '$first': '#_motiondevtools first.Menu, #_motiondevtools .Menu.first, #_motiondevtools .ViewMenu.first, #_motiondevtools .Menu > .first',
      '$last': '#_motiondevtools last.Menu, #_motiondevtools .Menu.last, #_motiondevtools .ViewMenu.last, #_motiondevtools .Menu > .last',
      '$hl': '#_motiondevtools hl.Menu, #_motiondevtools .Menu.hl, #_motiondevtools .ViewMenu.hl, #_motiondevtools .Menu > .hl',
      '$main': '#_motiondevtools main.Menu, #_motiondevtools .Menu.main, #_motiondevtools .ViewMenu.main, #_motiondevtools .Menu > .main'
    }, {
      '$menu': {
        border: '1px solid #ddd',
        boxShadow: '0 0 10px rgba(0,0,0,0.2)',
        position: 'absolute',

        background: '#fff',
        zIndex: 2147483647,
        transition: 'opacity ease-in 30ms, transform ease-in 30ms',
        opacity: 0,

        pointerEvents: 'none',
        padding: 0
      },
      '$active': {
        pointerEvents: 'auto',
        opacity: 1
      },
      '$item': {
        minWidth: 120,
        cursor: 'pointer',
        flexFlow: 'row'
      },
      '$first': {
        overflow: 'hidden'
      },
      '$last': {
        overflow: 'hidden'
      },
      '$hl': {
        padding: [4, 8]

      },
      '$main': {
        flexGrow: 1
      }
    });
    Motion.viewRoots["Menu"] = 'menu';
    Motion.view('Menu', function (view, on, $) {
      var active = false;
      var top = undefined,
          left = undefined;
      var elements = [];

      // prevent select and show custom cursor when ready for context
      var focused = undefined;
      on.keydown(function () {
        if (_keys.keys.alt && _keys.keys.command) {
          document.body.classList.add('__motionfocus');
          view.set('focused', focused = true);
        }
        view.updateSoft();
      });
      on.keyup(function () {
        if (focused) {
          document.body.classList.remove('__motionfocus');
          view.set('focused', focused = false);
        }
        view.updateSoft();
      });

      on.click(window, function (e) {
        if (active) {
          e.stopPropagation();
          e.preventDefault();
          view.set('active', active = false);
          view.updateSoft();
          return;
        }

        var mode = _keys.keys.alt && _keys.keys.command;
        if (!mode) return;

        e.preventDefault();

        var clientX = e.clientX;
        var clientY = e.clientY;

        view.set('left', left = clientX);
        view.set('top', top = clientY);
        view.set('active', active = true);
        view.set('elements', elements = _libInspecting2.default.all());
        view.updateSoft();
      });

      function focusElement(el) {
        return function () {
          toEditor({ type: 'focus:element', key: el.key, view: el.view });
        };
      }

      function focusStyle(el) {
        return function () {
          toEditor({ type: 'focus:style', el: el.el, view: el.view });
        };
      }

      ;view.render(function () {
        return view.el(
          ['menu', 1],
          { className: { internal: true, active: active } },
          Motion.range(elements.filter(function (i) {
            return !!i.view;
          })).map(function (_, _index) {
            return view.el(
              ['item', 1, _, _index],
              {
                repeat: elements.filter(function (i) {
                  return !!i.view;
                }),
                className: {
                  first: _index == 0,
                  last: _index == elements.length - 1
                }
              },
              view.el(
                ['main', 1, _, _index],
                { className: 'hl', onClick: focusElement(_) },
                _.view
              ),
              view.el(
                ['sub', 1, _, _index],
                { className: 'hl', onClick: focusStyle(_) },
                '$'
              )
            );
          })
        );
      });

      var rad = 5;

      $["menu"] = function (_, _index) {
        return {
          borderRadius: rad, top: top,
          left: left, transform: { y: -10 } };
      };

      $["active"] = function (_, _index) {
        return { transform: { y: 0 }
        };
      };

      $["first"] = function (_, _index) {
        return {
          borderTopLeftRadius: rad,
          borderTopRightRadius: rad };
      };

      $["last"] = function (_, _index) {
        return {
          borderBottomLeftRadius: rad,
          borderBottomRightRadius: rad };
      };

      $["hl"] = function (_, _index) {
        return { hover: {
            background: [0, 0, 0, 0.1]
          }
        };
      };
    });
  })
})();
//# sourceMappingURL=menu.js.map
